import {
	BtnThemeSetList,
    DomUtil,
    ThemeSet,
    StringUtil,
    DBxEvent,
    ThematicSchemeManager
} from "cartovista";
import {_createThemes, createThemeSetElement, parseConfig} from "cartovistaExtend/utils/CvUtils";
import "styles/MasterBtnThemeSetList.css";﻿

const themeSetListMasterHtml = '<button id="btnThemeSetListMaster" class="cv-btnThemeSetList" style="background-color:#095797"></button>'

    class MasterThemeSet extends ThemeSet{
        constructor(id, masterThemeSetConfig){
            super(id);
            this.id = id;
            this.title = masterThemeSetConfig.TITLE;
            this._map = window.cartovista.externalInterface.map;
            this.visibleLayers = _.map(masterThemeSetConfig.VIVIBLE_LAYERS, (visibleLayerId) => this._map.getLayer(visibleLayerId));
            this.showVisibleLayersInLayerControl = masterThemeSetConfig.SHOW_VISIBLE_LAYERS_IN_LAYER_CONTROL;
            this._layerControlViewController = window.cartovista.getUIController(this._map).findInstance("layerControlView");
            this._chartViewController = window.cartovista.getUIController(this._map).findInstance("chartView");
            this.updateThemes = masterThemeSetConfig.UPDATE_THEMES;
            this.themesText = masterThemeSetConfig.THEMES_TEXT;
        }

        applyThemeSet(){
            this.updateLayersVisibility(true);
            if(this.showVisibleLayersInLayerControl) this.updateLayerControlView();
            if(this.updateThemes){
                ThematicSchemeManager.removeAllThematicSchemes();
                this.checkThemes();
            }
        }

        filterThemesetConfigs(themeSetsConfigs){
            return _.map(themeSetsConfigs, function(themeSetConfigs){
                    if(themeSetConfigs.TYPE == "ThemeSetGroup" && !_.includes(themeSetConfigs.MASTER_THEMESETS_REMOVE, this.id)){
                        themeSetConfigs.THEMESETS_ELEMENTS = _.compact(this.filterThemesetConfigs(themeSetConfigs.THEMESETS_ELEMENTS));
                        return themeSetConfigs;
                    } else{
                        if(!_.includes(themeSetConfigs.MASTER_THEMESETS_REMOVE, this.id)){
                            return themeSetConfigs;
                        }
                    }
            }.bind(this));
        }

        checkThemes(){
            this.activeThemeSetId = this._map.activeThemeSet ? this._map.activeThemeSet.id : null;
            _.map(C.THEMESETS_ELEMENTS, (c) => c.TYPE == "ThemeSetGroup" ? this._map.removeThemeSetElement(this._map.getThemeSetGroup(c.ID)) : this._map.removeThemeSetElement(this._map.getThemeSet(c.ID)));
            var themeSetsElements = _.map(parseConfig(_.compact(this.filterThemesetConfigs(_.cloneDeep(C.THEMESETS_ELEMENTS))), {VALUE: this.id, TEXT: this.themesText}), createThemeSetElement);
            this._map.addThemeSetElement(themeSetsElements);
            this._map.activeThemeSet = this._map.getThemeSet(this.activeThemeSetId);
        }

        _toggleVisibleCharts() {
            if(this._chartViewController){
                _.forEach(this._chartViewController._chartContainers, function(chart){
                    if(chart._currentChart.data._interactiveLayer && chart._currentChart.data._interactiveLayer.visible){
                        chart._element.style.display = "";
                    }else {
                        chart._element.style.display = "none";
                    }
                });
                this._chartViewController._refreshCharts();
            }
        };

        unapply() {
           this.updateLayersVisibility(false);
            if(this.showVisibleLayersInLayerControl) this.updateLayerControlView();
        }

        updateLayerControlView(){
            this._layerControlViewController.isInvalidated = true;
            this._layerControlViewController._updateUI();            
        }

        updateLayersVisibility(visible){
            _.forEach(this.visibleLayers, function(layer){
                layer.visible = visible;
                if(this.showVisibleLayersInLayerControl) layer.isVisibleInLayerControl = visible;
            }.bind(this));
            _.delay(function(){this._toggleVisibleCharts();}.bind(this), 0);
        }

    }

    export default class MasterBtnThemeSetList extends BtnThemeSetList{
        constructor(activeThemeSet){
            $("[data-cv-role='mapTitle']").after(themeSetListMasterHtml);
            super($("#btnThemeSetListMaster")[0], {
                "map": window.cartovista.externalInterface.map, 
                "mapController": window.cartovista.getMapController(window.cartovista.externalInterface.map)
            });
            window.cartovista.addEventListener("MasterBtnThemeSetList_onMasterThemeSetChange", this._onMasterActiveThemeSetChanged, this);
            this._activeMasterThemeSet = null;
            if (activeThemeSet){
                var themeSet = _.find(this.masterThemeSets, {id: activeThemeSet});
                window.cartovista.dispatchEvent(new DBxEvent("MasterBtnThemeSetList_onMasterThemeSetChange", {"masterThemeSet": themeSet, "constructor_event": true}));
            }
        }

        _updateUI() {
            if (!1 === this._themeSetListInitialised) {
                this.masterThemeSets = _.map(C.MASTER_THEMESETS_ELEMENTS, (masterThemeSetConfig) => new MasterThemeSet(masterThemeSetConfig.ID, masterThemeSetConfig));
                this.treeView.setElements(this.masterThemeSets);
                this._themeSetListInitialised = !0,
                this.options.syncActiveThemeset ? this.masterThemeSets && this.masterThemeSets.length > 0 ? DomUtil.removeClass(this.element, "cv-invisible") : DomUtil.addClass(this.element, "cv-invisible") : this.masterThemeSets && this.masterThemeSets.length > 0 ? DomUtil.removeClass(this.element, "cv-visibilitity-hidden") : DomUtil.addClass(this.element, "cv-visibilitity-hidden")
            }
        }

        _onThemeSetElementsChanged(e){}

        _onActiveThemeSetChanged(e) {//quand sub themeset change
            if(this._activeMasterThemeSet) this._activeMasterThemeSet.updateLayersVisibility(true);
         }

         _onMasterActiveThemeSetChanged(e){
            if(this._activeMasterThemeSet) this._activeMasterThemeSet.unapply();
            var themeSet = e.source.masterThemeSet;
            themeSet.applyThemeSet();
            this.spanText.innerHTML = StringUtil.escapeHtml(themeSet.title);
            this._createTooltip();
            this._activeMasterThemeSet = themeSet;
            this.treeView.selectThemeSetElement(themeSet);
         }

        _onSelect_treeView(e, t) {
            var themeSet = t._adapter._themeSet;
            this.toggleOff();
            window.cartovista.dispatchEvent(new DBxEvent("MasterBtnThemeSetList_onMasterThemeSetChange", {"masterThemeSet": themeSet}));
        }
                      
        _onClick_treeView(e, t, i) {
            this.toggleOff()
        }

        _onLocaleChanged(e) { }
    }